import { Competition } from '@langlois/model-competition';
import { cad } from '@langlois/currency';

export function setCompetition (state, newCompetition) {
	const competition = new Competition(newCompetition);

	competition.events.forEach(
		event => event.prizes.forEach(
			// convert event prizes to numbers
			prize => prize.baseAmount = cad(prize.baseAmount)
		)
	);

	const existingCompetitionIndex = state.competitions.findIndex(c => c.id === competition.id);

	if (existingCompetitionIndex >= 0) {
		return state.competitions[existingCompetitionIndex] = competition;
	}

	state.competitions.push(competition);
}
